import { Component } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { Observable, BehaviorSubject, of, zip} from 'rxjs';
import { NgEmployeeXpermissionGroup, NgPermissions } from 'src/models';
import { tap, switchMap, map, take} from 'rxjs/operators';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { environment } from 'src/environments/environment';
import { Validators } from '@angular/forms';
import { MessageService } from 'src/app/services/message/message.service';
import { AimsCommonConfirmDialogComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { DialogComponent, SpinnerText } from 'src/app/services/message/message.enum';
import { GetTextPipe } from 'src/app/pipes';
import { MatDialog } from '@angular/material/dialog';
import { UserLookupColumns, ActiveUserLookupColumns } from '../permissions.component';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';


@Component({
  selector: 'user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrls: ['../permissions.component.css', './user-permissions.component.css'],
  providers: [GetTextPipe]
})

export class UserPermissionsComponent {

  constructor(
      private transferHttp: TransferHttpService,
      private dialog: MatDialog,
      public permissionsService: PermissionsService,
      private messageService: MessageService,
      private getTextPipe: GetTextPipe) {
  }

  arctecFunds: number = 0;
  oaFunds: number = 0;
  govtFunds: number = 0;
  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  currentUser = this.transferHttp.getCache('user');
  canCreate = this.permissionsService.canCreate(this.permissionsService.ComponentID.GroupPermissions);
  canUpdate = this.permissionsService.canUpdate(this.permissionsService.ComponentID.GroupPermissions);
  canDelete = this.permissionsService.canDelete(this.permissionsService.ComponentID.GroupPermissions);
  canCloneUser = this.permissionsService.canCreate(this.permissionsService.ComponentID.CloneUserPermissions);
  isCloneUser: BehaviorSubject<boolean> = new BehaviorSubject(false);
  permissions: AimsCommonTablePermissions = { create: this.canCreate, update: this.canUpdate, delete: this.canDelete, export: false }
  clonePermissions: AimsCommonTablePermissions = { create: false, update: false, delete: false, export: false }

  //Clone User
  cloneUserPermissionsSelected: NgPermissions[] = [];
  cloneUserGroupsSelected: NgEmployeeXpermissionGroup[] = [];

  //Dropdown Values
  groupValues;
  sourceUsers = this.permissionsService.getUsers();
  destinationUsers = this.getActiveUsers(this.sourceUsers);
  components = this.permissionsService.getComponents();

  //Columns
  userLookupColumns = UserLookupColumns;
  activeUserLookupColumns = ActiveUserLookupColumns;

  userPermissionsColumns: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'component.component', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC, validatorOrOpts: [ Validators.required ] },
    { key: 'component.description', label: 'Description', type: AimsCommonTableHeaderType.HTML, filter: false, editable: false, width:400 },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean' },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean' },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean' },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean' },
    { key: 'component', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC, hidden: true },
  ];
  cloneSourceUserPermissionsColumns: AimsCommonTableHeader[] = [
    { key: 'select', label: 'Clone', type: 'checkbox', filter: false },
    { key: 'component.component', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 }
  ];
  cloneDestinationUserPermissionsColumns: AimsCommonTableHeader[] = [
    { key: 'component.component', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 }
  ];
  userGroupsColumns: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    {
      key: 'permissionGroupId', label: 'Group Name', type: AimsCommonTableHeaderType.DYNAMIC, validatorOrOpts: [ Validators.required ],
      events: { filterAndSort: (element) => this.getTextPipe.transform(element.permissionGroupId, 'permissionGroupId', 'permissionGroupName', this.groupValues)}
    },
    { key: 'description', label: 'Description', type: AimsCommonTableHeaderType.DYNAMIC }
  ];
  cloneUserGroupsColumns: AimsCommonTableHeader[] = [
    { key: 'select', label: 'Clone', type: 'checkbox', filter: false },
    {
      key: 'permissionGroupId', label: 'Group Name', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => this.getTextPipe.transform(element.permissionGroupId, 'permissionGroupId', 'permissionGroupName', this.groupValues)}
    }
  ];
  componentNameLookupColumns:AimsCommonTableHeader[] = [
    { key: 'component', label: 'Component', type: AimsCommonTableHeaderType.STRING },
    { key: 'parentComponentName', label: 'Parent', type: AimsCommonTableHeaderType.STRING },
    { key: 'description', label: 'Description', type: AimsCommonTableHeaderType.HTML }
  ];
  groupNameLookupColumns:AimsCommonTableHeader[] = [
    { key: 'permissionGroupName', label: 'Group Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'description', label: 'Description', type: AimsCommonTableHeaderType.STRING }
  ];
  //When a table is empty, it needs a default object to add rows correctly
  defaultPermissionsAddRowInitialObject = {
    permissionId: '',
    componentId: '',
    employee: '',
    employeeId: '',
    permissionGroup:'',
    permissionGroupId: '',
    create: false,
    delete: false,
    read: false,
    update: false,
    tenant: '',
    component:{
      componentId: '',
      component: '',
      parentComponentId: '',
      parentComponentName: '',
      description: ''
    }
  };
  defaultGroupsAddRowInitialObject = {
    employeeXpermissionGroupId:'',
    employeeId:'',
    permissionGroup:null,
    permissionGroupId:'',
    tenant:null,
    tenantId:'',
    user:null,
    userId:''
  };


  //default to the logged in user
  sourceUser: BehaviorSubject<any> = new BehaviorSubject({
    userName: this.currentUser.loginName,
    userId: this.currentUser.userId,
    tenantId: this.currentUser.tenantId,
    employeeId: this.currentUser.employeeId
  });
  destinationUser: BehaviorSubject<any> = new BehaviorSubject({
    userName: null,
    userId: null,
    tenantId: null,
    employeeId: null
  });

  sourceUserPermissions: Observable<Array<NgPermissions>> = this.sourceUser.pipe(
    tap(p => {
      this.messageService.getSpinnerText(SpinnerText.Load);
      this.showSpinner = true;
    }),
    switchMap(user => {
      let p:Observable<Array<NgPermissions>> = of(new Array<NgPermissions>())
      if(user && user.userId){
        p = this.permissionsService.getUserPermissionsOnly(user.userId).pipe(
          tap(p => {
            this.sourceUserPermissionsDataSource = p;
            this.permissionsService.getUserPurchaseAuth(user.userId).pipe(take(1)).subscribe(r => {
                this.arctecFunds = r.companyPurchaseAuth;
                this.oaFunds = r.oapurchaseAuth;
                this.govtFunds = r.govtPurchaseAuth;
                this.showSpinner = false;
            });
          })
        )
      }
      return p;
    }),
    tap(g => {this.showSpinner = false})
  );
  destinationUserPermissions: Observable<Array<NgPermissions>> = this.destinationUser.pipe(
    tap(p => {
      this.messageService.getSpinnerText(SpinnerText.Load);
      this.showSpinner = true;
    }),
    switchMap(user => {
      let p = of(new Array<NgPermissions>());
      if (user && user.userName) {
        p =  this.permissionsService.getUserPermissionsOnly(user.userId).pipe(
          tap(p => {
            this.destinationUserPermissionsDataSource = p;
            this.showSpinner = false
          })
        )
      }
      return p;
    }),
    tap(p => {
      this.showSpinner = false
    })
  );
  sourceUserGroupMembership: Observable<Array<NgEmployeeXpermissionGroup>> = this.sourceUser.pipe(
    tap(g => {
      this.messageService.getSpinnerText(SpinnerText.Load);
      this.showSpinner = true;
    }),
    switchMap(user => {
      let m = of(new Array<NgEmployeeXpermissionGroup>());
      if(user && user.userName){
        m = this.permissionsService.getUserGroups(user.userId).pipe(
          tap(p => {
            this.sourceUserGroupsDataSource = p;
            this.showSpinner = false;
          })
        )
      }
      return m
    }),
    tap(g => {this.showSpinner = false})
  );
  destinationUserGroupMembership: Observable<Array<NgEmployeeXpermissionGroup>> = this.destinationUser.pipe(
    tap(m => {
        this.messageService.getSpinnerText(SpinnerText.Load);
        this.showSpinner = true;
    }),
    switchMap(user => {
      let m = of(new Array<NgEmployeeXpermissionGroup>());
      if(user && user.userName){
        m = this.permissionsService.getUserGroups(user.userId).pipe(
          tap(p => {
            this.destinationUserGroupsDataSource = p;
            this.showSpinner = false;
          })
        )
      }
      return m;
    }),
    tap(p => {
      this.showSpinner = false;
    })
  );

  imgSrc: string = environment.assetsPath;

  //Table datasource
  sourceUserPermissionsDataSource: NgPermissions[];
  sourceUserGroupsDataSource: NgEmployeeXpermissionGroup[];
  destinationUserPermissionsDataSource: NgPermissions[];
  destinationUserGroupsDataSource: NgEmployeeXpermissionGroup[];

  //Spinner
  spinnerText: string = this.messageService.getSpinnerText(SpinnerText.Load);
  showSpinner: boolean = false;

  //Clone User Handlers
  handleOpenCloneUser(){
    this.isCloneUser.next(true);
  }
  handleCloneUser(){
    //Add (don't replace) if the destination user isn't already in it
    //TODO: Handle error when user already has all groups and permissions. Message?
    let issueCloningPermissions: NgPermissions[] = new Array<NgPermissions>();
    let issueCloningGroups: NgEmployeeXpermissionGroup[] = new Array<NgEmployeeXpermissionGroup>();

    zip(this.destinationUserPermissions, this.destinationUserGroupMembership)
      .pipe(take(1))
      .subscribe(([_destinationUserPermissions,_destinationUserGroupMembership]) => {
      var destinationUserPermissions = _destinationUserPermissions;
      var destinationUserGroupMembership = _destinationUserGroupMembership;

      //Filter out groups the destination user is already in
      var filteredSelectedPermissions = this.cloneUserPermissionsSelected.filter(selectedComponent => {
        var found = destinationUserPermissions.find(perm => perm.componentId == selectedComponent.componentId)
        if(found){
          //push a copy of the duplicate, otherwise modifications later will affect the original object
          issueCloningPermissions.push(Object.assign(found));
          return false
        }else{return true;}
      });
      var filteredSelectedGroups = this.cloneUserGroupsSelected.filter(selectedGroup => {
        var found = destinationUserGroupMembership.find(group => group.permissionGroupId == selectedGroup.permissionGroupId)
        if(found){
          issueCloningGroups.push(Object.assign(found));
          return false
        }else{return true;}
      });

      //Prevent users adding duplicate groups or permission to destination user.
      //Could just add the filteredSelected items, but it might surprize people
      //This is required since table vs table comparison/highlighting isn't feasible right now.
      let showDialog = false;
      if(this.cloneUserPermissionsSelected.length > filteredSelectedPermissions.length){
        showDialog = true;
      }
      if(this.cloneUserGroupsSelected.length > filteredSelectedGroups.length){
        showDialog = true;
      }
      if(showDialog){
        this.handleCloneDialog(issueCloningGroups, issueCloningPermissions);
      }else{
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Permissions");
        this.showSpinner = true;
        for(var permission of filteredSelectedPermissions){
          permission.userId = this.destinationUser?.value.userId;
          permission.employeeId = this.destinationUser?.value.employeeId;
          permission.permissionId = 0;//create a new one
          this.permissionsService.savePermission(permission).subscribe(result=>{
            if(filteredSelectedPermissions[filteredSelectedPermissions.length -1] == permission){
              //everything is done. refresh destination user grid
              this.destinationUser.next(this.destinationUser.value);
              this.showSpinner = false;
              this.cloneUserPermissionsSelected = [];
            }
          });
        }
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Groups");
        this.showSpinner = true;
        for(var permissionGroup of filteredSelectedGroups){
          permissionGroup.userId = this.destinationUser?.value.userId;
          permissionGroup.employeeId = this.destinationUser?.value.employeeId;
          permissionGroup.employeeXpermissionGroupId = undefined;//create a new one
          this.permissionsService.saveMembership(permissionGroup.employeeXpermissionGroupId, permissionGroup.permissionGroupId, permissionGroup.userId, permissionGroup.employeeId).subscribe((result)=>{
            if(filteredSelectedGroups[filteredSelectedGroups.length -1] == permissionGroup){
              //everything is done. refresh destination user grid
              this.destinationUser.next(this.destinationUser.value);
              this.showSpinner = false;
              this.cloneUserGroupsSelected = [];
            }
          });
        }
      }
    });
  }
  handleCancelClone(){
    this.isCloneUser.next(false);
    this.destinationUser.next(this.clearUser());
  }
  clearUser(){
    return new BehaviorSubject({
      userName: null,
      userId: null,
      tenantId: null,
      employeeId: null
    })
  }
  handleCloneUserPermissionRowClick($event){
    this.cloneUserPermissionsSelected = $event.selections;
  }
  handleCloneUserGroupRowClick($event){
    this.cloneUserGroupsSelected = $event.selections;
  }
  handleCloneDialog(issueCloningGroups:NgEmployeeXpermissionGroup[], issueCloningPermissions:NgPermissions[]){
    var message = this.messageService.getDialogMessage(DialogComponent.CloneUser);
    message.message = "";
    //Show a list that the user needs to fix
    if(issueCloningGroups.length > 0){
      message.message += "Destination user is already in the " + (issueCloningGroups.length==1?"group":"groups") + "<ul>";
      for(const item of issueCloningGroups){
        var groupName = this.getTextPipe.transform(item.permissionGroupId, 'permissionGroupId', 'permissionGroupName', this.groupValues)
        message.message += "<li>" + groupName + "</li>";
      }
      message.message += "</ul>";
    }
    if(issueCloningPermissions.length > 0){
      message.message += "Destination user already has " + (issueCloningPermissions.length == 1? "this Permission" : "these Permissions" ) + ": <ul>";

      for(const item of issueCloningPermissions){
        message.message += "<li>" + item.component.component + "</li>";
      }
      message.message += "</ul>";
    }
    message.message += "Please remove these and clone groups or permissions that " + this.destinationUser?.value.userName + " is not already in";

    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
      data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      dialogRef = null;
    });
  }
  handleBlurArctecFundsPurchaseAuth($event){
    this.arctecFunds = $event;
    this.savePurchaseAuth();
  }
  handleBlurOAFundsPurchaseAuth($event){
    this.oaFunds = $event;
    this.savePurchaseAuth();
  }
  handleBlurGovtFundsPurchaseAuth($event){
    this.govtFunds = $event;
    this.savePurchaseAuth();
  }
  //Permissions Event Handlers
  handlePermissionsRowAdd(update: TableRowUpdate){
    this.sourceUserPermissionsDataSource = [update.newRow as NgPermissions, ...this.sourceUserPermissionsDataSource];
    this.handlePermissionsRowUpdate(update, true)
  }
  handlePermissionsRowCancelled(update: TableRowUpdate): void {
    // Remove temp if cancelled
    if (!(update.oldRow as NgPermissions).permissionId) {
        this.sourceUserPermissionsDataSource = this.sourceUserPermissionsDataSource.filter(i => i.permissionId)
    }
  }
  handlePermissionsRowUpdate(update: TableRowUpdate, add?: boolean): void {
    var row = update.newRow as NgPermissions;
    this.sourceUserPermissionsDataSource[update.index] = update.newRow as NgPermissions
    this.sourceUserPermissionsDataSource = [...this.sourceUserPermissionsDataSource]
    //save NgPermissions

    //Create save object, can't reuse row b/c spread operator flattened it
    var permission = new NgPermissions();
    if (add) { permission.permissionId = undefined } else { permission.permissionId = row.permissionId; }
    permission.componentId = row.component.componentId;
    permission.create = row.create;
    permission.delete = row.delete;
    permission.read = row.read;
    permission.update = row.update;
    permission.userId = this.sourceUser.value.userId;
    permission.tenantId = this.sourceUser.value.tenantId;
    permission.employeeId = this.sourceUser.value.employeeId;

    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Permission");
    this.showSpinner = true;
    this.permissionsService.savePermission(permission)
      .subscribe({
        next: retVal => {
          this.showSpinner = false;
          if (add) { // Need to update the added object's id
            this.sourceUserPermissionsDataSource[0].permissionId = retVal.savedEntity.permissionId;
            this.sourceUserPermissionsDataSource = [...this.sourceUserPermissionsDataSource];
          }
        },
        error: err => {
          this.showSpinner = false;
        }
  });
  }
  handlePermissionsRowDelete(row: TableRowDelete):void{
    //update the datasource
    this.sourceUserPermissionsDataSource.splice(row.index, 1);
    this.sourceUserPermissionsDataSource = [...this.sourceUserPermissionsDataSource];

    //save
    const permission = row.row as NgPermissions;
    if(permission && permission.permissionId){
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Delete, "Permission");
        this.showSpinner = true;
        this.permissionsService.deletePermission(permission.permissionId)
          .subscribe(retVal => {
            this.showSpinner = false;
          },
          error => {
              this.showSpinner = false;
          });
    }
  }
  //Groups Event Handlers
  handleGroupsRowAdd(update: TableRowUpdate){
    this.sourceUserGroupsDataSource = [update.newRow as NgEmployeeXpermissionGroup, ...this.sourceUserGroupsDataSource];
    this.handleGroupsRowUpdate(update, true)
  }
  handleGroupsRowCancelled(update: TableRowUpdate): void {
    // Remove temp if cancelled
    if (!(update.oldRow as NgEmployeeXpermissionGroup).employeeXpermissionGroupId) {
        this.sourceUserGroupsDataSource = this.sourceUserGroupsDataSource.filter(i => i.employeeXpermissionGroupId)
    }
  }
  handleGroupsRowUpdate(update: TableRowUpdate, add?: boolean): void {
    var row = update.newRow as NgEmployeeXpermissionGroup;
    this.sourceUserGroupsDataSource[update.index] = update.newRow as NgEmployeeXpermissionGroup
    this.sourceUserGroupsDataSource = [...this.sourceUserGroupsDataSource]
    //save NgPermissions

    //Create save object, can't reuse row b/c spread operator flattened it
    var permissionGroup = new NgEmployeeXpermissionGroup();
    if(add) { permissionGroup.employeeXpermissionGroupId = undefined } else { permissionGroup.employeeXpermissionGroupId = row.employeeXpermissionGroupId; }
    permissionGroup.permissionGroupId = row.permissionGroupId;
    permissionGroup.userId = this.sourceUser.value.userId;
    permissionGroup.tenantId = this.sourceUser.value.tentantId;

    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Group Membership");
    this.showSpinner = true;
    this.permissionsService.saveMembership(permissionGroup.employeeXpermissionGroupId, permissionGroup.permissionGroupId, permissionGroup.userId, permissionGroup.employeeId)
      .pipe(take(1))
      .subscribe(retVal => {
        this.showSpinner = false;
        if (add) { //Update the added object's id
            this.sourceUserGroupsDataSource[0].employeeXpermissionGroupId = retVal.savedEntity.employeeXpermissionGroupId;
            this.sourceUserGroupsDataSource = [...this.sourceUserGroupsDataSource];
        }
    },error => {
        this.showSpinner = false;
    })
  }
  handleGroupsRowDelete(row: TableRowDelete):void{
    //update the datasource
    this.sourceUserGroupsDataSource.splice(row.index, 1);
    this.sourceUserGroupsDataSource = [...this.sourceUserGroupsDataSource];

    //save
    const permissionGroup = row.row as NgEmployeeXpermissionGroup;
    if(permissionGroup && permissionGroup.employeeXpermissionGroupId){
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Delete, "Group Membership");
        this.showSpinner = true;
        this.permissionsService.deleteGroupMember(permissionGroup.employeeXpermissionGroupId)
          .pipe(take(1))
          .subscribe(retVal => {
            this.showSpinner = false;
        });
    }
  }
  //Lookup Event Handlers
  handleSourceUserLookupChange(dataItem) {
    if (!dataItem) {
      this.sourceUser.next(this.clearUser());
    }
    this.sourceUser.next(dataItem);
  }
  handleDestinationUserLookupChange(dataItem){
    if(!dataItem){
      this.destinationUser.next(this.clearUser());
    }
    this.destinationUser.next(dataItem);
  }
  handleComponentLookupChange(dataItem, element:NgPermissions,control){
    if (!dataItem) {
      dataItem = {} // We want to patch below with a null/undefined value
    }
    control.parent.patchValue({
      'component':dataItem,
      'component.component': dataItem.component
    })
  }
  handleGroupsAimsLookupChange(dataItem, element:NgPermissions, control){
    if (!dataItem) {
      dataItem = {} // We want to patch below with a null/undefined value
    }
    control.parent.patchValue({
      'permissionGroupId':dataItem.permissionGroupId,
      'permissionGroupName': dataItem.permissionGroupName
    })
    element.permissionGroup = dataItem.permissionGroupName;
    control.parent.markAsTouched()
  }
  savePurchaseAuth() {
    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Purchase Auth");
    this.showSpinner = true;
    this.permissionsService.savePurchaseAuth(this.sourceUser.value.userId, this.arctecFunds, this.oaFunds, this.govtFunds)
    .pipe(take(1))
    .subscribe(ret => {
      this.showSpinner = false;
    })
  }
  getActiveUsers(users:Observable<any>) {
      var data = users.pipe(map(results => results.filter(user => user.active)));
      return data;
  }
  getSourceUserPermissionsReportLabel(){
    var label = "";
    if(this.isCloneUser.value == true && this.sourceUser?.value.userName != ''){
      label = 'Source User ' + this.sourceUser?.value.userName
    }
    return label;
  }
  getDestinationUserPermissionsReportLabel(){
    var label = "";
    if(this.isCloneUser.value == true && this.destinationUser?.value.userName != ''){
      label = 'Desination User ' + this.destinationUser?.value.userName;
    }
    return label;
  }

  ngOnInit(): void {
    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Load);
    this.showSpinner = true;

    this.permissionsService.getPermissionGroups().pipe(take(1)).subscribe(groups => {
      this.groupValues = groups
      this.showSpinner = false;
    });
  }
  ngOnDestroy(){
    this.sourceUser.complete();
    this.sourceUser.unsubscribe();
    this.destinationUser.complete();
    this.destinationUser.complete();
  }

}
